import React, {lazy, Suspense} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import "./index.css";
import Header from "./components/Header";
import Footer from "./components/Footer";

const HomePage = lazy(() => import('./pages/HomePage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const RegisterPage = lazy(() => import('./pages/RegisterPage'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage'));

function App() {

    return (
        <Router>
            <Suspense fallback={<div>Loading...</div>}>
                <div className="min-h-screen flex flex-col">
                    <Header/>
                    <main className="flex-1">
                        <Routes>
                            <Route path="/" element={<HomePage/>}/>
                            <Route path="/login" element={<LoginPage/>}/>
                            <Route path="/register" element={<RegisterPage/>}/>
                            <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
                        </Routes>
                    </main>
                    <Footer/>
                </div>
            </Suspense>
        </Router>
    );
}

export default App;